import { render } from "./AdminLink.vue?vue&type=template&id=c698292e"
import script from "./AdminLink.vue?vue&type=script&lang=js"
export * from "./AdminLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__